import React, { useState } from 'react'
import atoms from '../../../atoms'
import molecules from '../../../molecules'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import service from '../../../../api/services'
import { useToasts } from 'react-toast-notifications';
import { checkPermissionsInArray } from '../../../../constants/utils';
import { AllPermissions } from '../../../../constants/permissions';
const { Search, Button, Table, Input } = atoms
const { ConfirmationModal, CreateModal } = molecules

const Index = ({ setSearch, shapeListing, getShapeListing }: any) => {
    const { addToast } = useToasts();
    const [handleDeleteModal, setHandleDeleteModal] = useState<boolean>(false)
    const [errors, setErrors] = useState<boolean>(false)
    const [createModal, setCreateModal] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [shapeValues, setProductShapeValues] = useState({ name: '', })
    const [selectedId, setSelectedId] = useState<string>('')
    const columns = [
        { name: 'Shape Name', selector: (row: any) => row.name, sortable: true, },
        { name: 'Action', selector: (row: any) => row.action, },

    ]
    const handleSubmit = async () => {

        const payload = {
            name: shapeValues.name,
        }
        if (shapeValues.name) {
            try {
                if (isEdit) {
                    // for update product type values
                    const response = await service.productData.updateProductShapeService(selectedId, payload)
                    if (response.status === 200) {
                        setCreateModal(false)
                        addToast('Product shape updated successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                    }
                } else {
                    // for Create product type values
                    const response = await service.productData.createProductShapeService(payload)
                    if (response.status === 201) {
                        setCreateModal(false)
                        addToast('Product shape added successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                    }
                }
            } catch (error: any) {
                console.log("error", error);
                addToast(error.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
            getShapeListing()
            setProductShapeValues({
                name: '',
            })
            setIsEdit(false)
        } else {
            setErrors(true)
        }
    }
    const _handleDelete = (id: string) => {
        setSelectedId(id)
        setHandleDeleteModal(true)
    }
    const handleDeleteType = async () => {
        try {
            const response = await service.productData.deleteProductShapeService(selectedId)
            if (response.status === 200) {
                setHandleDeleteModal(false)
                addToast('Product shape deleted successfully', {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.log("error", error);
            setHandleDeleteModal(false)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
        getShapeListing()
    }

    const _handleEdit = async (id: string) => {
        setSelectedId(id)
        handleProductShapeValues(id)
    }
    const handleProductShapeValues = async (id: string) => {
        setIsEdit(true)

        try {
            const response = await service.productData.getProductShapeByIdService(id)
            let resData = response.data.data
            if (response.status === 200) {
                setProductShapeValues({
                    name: resData?.name,
                })
                setCreateModal(true)
            }
        } catch (error: any) {
            console.log("error", error);
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    const _handleClose = () => {
        setCreateModal(!createModal)
        setProductShapeValues({
            name: '',
        })
        setIsEdit(false)
    }
    const handleChange = (name: string, value: string) => {
        setProductShapeValues({ ...shapeValues, [name]: value })
        setErrors(false);
    }
    return (
        <div>
            <div>
                <div className="row align-items-center">
                    <div className="col-6">
                        <Search searchCallBack={(e: string) => { setSearch(e) }} />
                    </div>
                    {checkPermissionsInArray(AllPermissions.Shape_Add) && <div className="col-6 text-end">
                        <Button name={'Create Product Shape'}
                            onClick={() => setCreateModal(!createModal)}
                        />
                    </div>}
                </div>
            </div>
            <div>
                <Table
                    className="column-style"
                    columns={columns}
                    data={shapeListing?.data?.map((item: any) => {
                        return ({
                            ...item,
                            action: <>
                                {checkPermissionsInArray(AllPermissions.Shape_Edit) && <Button className="table-edit-button fs-14 fw-400"
                                    onClick={() => _handleEdit(item.id)}>
                                    <div className='d-flex align-items-center'>
                                        <FiEdit />
                                        <span className='ms-2 mb-0'>Edit</span>
                                    </div>
                                </Button>}
                                {checkPermissionsInArray(AllPermissions.Shape_Delete) && <Button className="table-delete-button fs-14 fw-400 ms-3"
                                    onClick={() => _handleDelete(item.id)}>
                                    <div className='d-flex align-items-center'>
                                        <RiDeleteBin6Line />
                                        <span className='ms-2 mb-0'>Delete</span>
                                    </div>
                                </Button>}
                            </>
                        })
                    })}
                />
            </div>
            {handleDeleteModal && <ConfirmationModal
                show={handleDeleteModal}
                handleConfirmItem={() => handleDeleteType()}
                onHide={() => setHandleDeleteModal(!handleDeleteModal)}
                message={'delete this Product Shape'} />}

            {createModal && <CreateModal
                show={createModal}
                header={`${isEdit ? 'Update' : 'Create'} Shape`}
                handleSubmit={handleSubmit}
                submitBtnText={`${isEdit ? 'Update' : 'Create'} Shape`}
                onHide={() => _handleClose()}
            >
                <div>
                    <form>
                        <div className="row">
                            <div className="col-12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Enter Shape Type"
                                    onChange={(e: any) => handleChange("name", e.target.value)}
                                    defaultValue={shapeValues.name}
                                    label='Shape Name'
                                />
                                {(errors && (shapeValues.name.length === 0)) && <span className="error-text">This field is required.</span>}
                            </div>
                        </div>
                    </form>
                </div>
            </CreateModal>}
        </div>
    )
}

export default Index